// Libs
import { useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
// Components, Layouts, Pages
// Others
import { StorageEnum } from '~/utils/enum/base';
import { RoleEnum } from '~/utils/enum/common';
import { authRoute } from '~/utils/routes/auth';
// Styles, images, icons

type Props = {
  roles: RoleEnum[];
};

const ProtectedRoute = (props: Props) => {
  //#region Destructuring Props
  const { roles } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [isLoggedIn] = useState<string | null>(localStorage.getItem(StorageEnum.ACCESS_TOKEN)! || null);
  const [currentRole] = useState<string | null>(localStorage.getItem(StorageEnum.ROLE) || null);
  //#endregion Declare State

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return isLoggedIn && roles.includes(currentRole as RoleEnum) ? <Outlet /> : <Navigate to={authRoute.base} />;
};

export default ProtectedRoute;
